<template>
  <div class="fts-profile">
    <!-- profile -->
    <avatar
      class="profile-photo"
      :class="profilePhotoClass"
      :size="profilePhotoSize"
      :username="userProfileName || ''"
      :src="userProfilePhoto"
      :custom-style="style"
      :background-color="!userProfileName ? 'var(--fts-default)' : null"
      v-if="profilePhoto"
    />
    <!-- user name -->   
    <div class="profile-name" :class="userProfileNameClass" v-if="profileName">
      <slot 
        name="profileName"
        :userProfile="userProfile"
        :userProfileName="userProfileName"
        :userProfileUsername="userProfileUsername"
      >
        <template v-if="profileGroup">
          <div class="profile-group-name">
            {{userProfileName}}
          </div>
          <div class="profile-group-tag">
            {{userProfileUsername}}
          </div>
        </template>
        <template v-else>
          {{userProfileName}}
        </template>
      </slot>
    </div>
  </div>
</template>

<script>
import webAppConfig from "../commons/webApp.config";
import commons from "../commons/commons";
import { store as canvasDesignStore } from "../store/canvasDesignStore";

import Avatar from "vue-avatar";

export default {
  props: {
    profile: Object,
    profilePhoto: {
      type: Boolean,
      default: true
    },
    profilePhotoClass: String,
    profilePhotoSize: {
      type: Number,
      default: 21,
    },
    profileName: {
      type: Boolean,
      default: true,
    },
    profileNameClass: String,
    profileGroup: Boolean,
    profileId: String,
    userName: String,
    userList: Array,
    fallbackName: String
  },
  components: {
    avatar: Avatar,
  },
  data: () => ({
    loaded: false,
  }),
  methods: {
    loadImage() {
      if (this.userProfilePhoto)
        commons.imageLoader(this.userProfilePhoto, 
          () => {
            this.loaded = true;
          },
          () => {
            this.loaded = false;
          }
        );
      else
        this.loaded = false;
    },
  },
  computed: {
    users() {
      return Array.isArray(this.userList) ? this.userList : canvasDesignStore.state.users || [];
    },
    userProfile() {
      if (this.profile) {
        return this.profile;
      } else if (this.userName) {
        const userName = this.userName.toLowerCase();

        return this.users.find(x => 
          (x.userName && x.userName.toLowerCase() === userName) || 
          (x.username && x.username.toLowerCase() === userName)
        ) || {};
      } else if (this.profileId) {
        return this.users.find(x => x.profileId === this.profileId) || {};
      } else {
        return {}
      }
    },
    userProfileUsername() {
      return this.userName ? this.userName : this.userProfile.username || this.userProfile.userName 
    },
    userProfileName() {
      return this.userProfile.displayName || this.userProfileUsername || this.fallbackName;
    },
    userProfilePhoto() {
      if (this.userProfile.profilePictureUrl)
        return webAppConfig.baseURL && this.userProfile.profilePictureUrl.startsWith('/') ?
          `${webAppConfig.baseURL}${this.userProfile.profilePictureUrl}` : this.userProfile.profilePictureUrl;
      else if (this.userProfileUsername === 'FETIAS-Bot')
        return commons.fetiasLogo;
      else if (
        !this.userProfileName || 
        this.userProfile.disable || 
        Object.keys(this.userProfile).length === 0
      )
        return commons.defaultProfileImage;
    },
    userProfileNameClass() {
      return this.profileNameClass ? this.profileNameClass : this.profileGroup ? 'profile-name--group' : 'default-profile-name';
    },
    style() {
      const style = {
        display: 'flex',
        width: `${this.profilePhotoSize}px`,
        height: `${this.profilePhotoSize}px`,
        minWidth: `${this.profilePhotoSize}px`,
        minHeight: `${this.profilePhotoSize}px`,
        borderRadius: '50%',
        lineHeight: `${(this.profilePhotoSize + Math.floor(this.profilePhotoSize / 20))}px`,
        fontWeight: 'bold',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        userSelect: 'none',
      }
      return this.userProfilePhoto ?
        {
          ...style,
          background: this.loaded ? 
          `url('${this.userProfilePhoto}') no-repeat scroll 0% 0% / ${this.profilePhotoSize}px ${this.profilePhotoSize}px content-box border-box` :
          `url('${commons.defaultProfileImage}') no-repeat scroll 0% 0% / ${this.profilePhotoSize}px ${this.profilePhotoSize}px content-box border-box`,
        } : style;
    }
  },
  beforeUpdate() {
    this.loadImage();
  },
  mounted() {
    this.loadImage();
  },
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-profile {
  min-width: 0;
  display: flex;
  align-items: center;
  .profile-name {
    color: var(--fts-text);
    &.default-profile-name {
      @include text-overflow-ellipsis;
    }
    &.profile-name--group {
      min-width: 0;
      display: flex;
      align-items: flex-start;
    }
  }
  .profile-photo + .profile-name {
    margin-left: 0.375rem;
  }
  .profile-group-name {
    @include text-overflow-ellipsis;
    & + .profile-group-tag {
      margin-left: 0.375rem;
    }
  }
  .profile-group-tag {
    @include text-overflow-ellipsis;
    flex-shrink: 2;
    color: var(--fts-default);
  }
}
</style>